import React, { useContext, useState } from 'react'
import ServiceMap from './ServiceMap';
import { ctcActivity, fetchMcatlist, getCreateOpportunity, updateSTS } from '../../services/merpservices';
import EmployeeContext from '../../utils/EmpDetails/EmployeeProvider';
import { useGlobalContext } from '../../SearchBar/SearchBar';
import { useGlobalAppContext } from '../../context/Context';
import ModalNew from '../Modal/ModalNew';
import { gaEvent } from '../../utils/GoogleAnalytics/gatracking';
import getHighestPriorityService from '../../utils/Misc/getHighestPriorityService';
import { Alert } from '../../utils/Alert';
const HotleadCreationForPaidSeller = ({descHiddenValue, stsId}) => {
    
    const employeeDetails = useContext(EmployeeContext); // we get empid, empid ak
    const { glusrData } = useGlobalContext(); // glusr details
    const { activeServiceData } = useGlobalAppContext(); // get active service details of glusr
    const serviceDetailsData = getHighestPriorityService(activeServiceData) || {};
    const { SERVICE_ID } = Array.isArray(serviceDetailsData) && serviceDetailsData.length > 0 ? serviceDetailsData[0] : serviceDetailsData;

    const [showModal, setShowModal] = useState(false);
    const [hotleadMessage, setHotleadMessage] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);

    const mcatListServices = [361, 364, 371];
    const createOpportunity = async () => {
        if(descHiddenValue === ""){
            Alert("Kindly fill the disposition first");
            return
        }
        if(SERVICE_ID === "348"){
            setHotleadMessage("<p style='text-align:center'>Hotlead can not be created as customer is already having highest service.</p>");
            setShowModal(true);
            return
        }else{
          const serviceDetails = ServiceMap.get(parseInt(SERVICE_ID) || parseInt(activeServiceData[0]?.SERVICE_ID));
          const { service_pitched, serviceForHL, deal_amt } = serviceDetails;
          let mcatID = '';
          let dealAmount = 0;
          let mcatName ='';
          if (mcatListServices.includes(service_pitched)) {
              const { mcatData } = await fetchingMCATList();
              mcatID = mcatData[0]?.MCAT_ID;
              mcatName = mcatData[0]?.MCAT_NAME;
              dealAmount = mcatData[0]?.SERVICE_PRICE;
          }
          const mcatData = [
              {"MCAT_ID":mcatID,"MCAT_NAME":mcatName,"SERVICE_PRICE":dealAmount}
          ];
          const AutoDialerIVR = `${glusrData?.glusr_usr_companyname} -- Hot lead on - ${serviceForHL} - via - 9696CRM`
          try {
              const res = await getCreateOpportunity(employeeDetails?.empid, employeeDetails?.ak, glusrData?.glusr_usr_id, service_pitched, deal_amt || dealAmount, AutoDialerIVR, `${serviceForHL}${mcatName ? `-${mcatName}` : ''}`, mcatID && JSON.stringify(mcatData));
              if(res?.data[0]?.data[0]?.message !== "Opportunity created successfully"){
                  updateSTS(employeeDetails?.empid, employeeDetails?.ak, stsId, employeeDetails?.empid, res?.data[0]?.data[0]?.message);
              }
              setHotleadMessage(`<p style='text-align:center'>${res?.data[0]?.data[0]?.message}</p>`);
              setShowModal(true);
          } catch (error) {
              console.log(error);
          }
        }
        await ctcActivity(employeeDetails?.empid, employeeDetails?.ak, employeeDetails?.ucid, 2);
        setIsDisabled(true);
        gaEvent(
            "Hot Lead New",
            "Hot Lead when customer is interested in paid/ higher paid packages New",
            "Hot Lead when customer is interested in paid/ higher paid packages New",
            "Hot Lead when customer is interested in paid/ higher paid packages New",
            glusrData?.glusr_usr_id
        );
    }

    const fetchingMCATList = async () => {
        try {
            const res = await fetchMcatlist(employeeDetails?.empid, employeeDetails?.ak, glusrData?.glusr_usr_id, 361);
            if (res?.data?.status === "200") {
                return res?.data?.data;
            }
        } catch (error) {
            console.log(error)
        }
    }
    
    return (
      <>
        <span
          onClick={() => {
            if (!isDisabled) {
              createOpportunity();
            }
          }}
          style={{
            cursor: isDisabled ? "not-allowed" : "pointer",
            backgroundColor:isDisabled ? 'lightgray' :''
          }}
        >
          Hot Lead
        </span>
        <ModalNew
          glid={glusrData?.glusr_usr_id}
          show={showModal}
          header=""
          history={hotleadMessage}
          onClose={() => setShowModal(false)}
          screen='es-popup'
        />
      </>
    )
}

export default HotleadCreationForPaidSeller;